import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Score from './Score';

export default
class LeaderboardScoreNeeds extends Component {
    static propTypes = {
        scoreStyle: PropTypes.object.isRequired,
        t: PropTypes.func.isRequired,
        athlete: PropTypes.object.isRequired,
        colors: PropTypes.object.isRequired,
        hide: PropTypes.bool
    }

    static defaultProps = {
        hide: false
    }

    render() {
        const {
            t,
            scoreStyle,
            athlete,
            colors,
            hide,
            children: needs = {}
        } = this.props;

        let style = athlete.isLive
            ? colors.extraActive
            : colors.extra;

        if (hide) {
            style = {
                ...style,
                opacity: 0
            };
        }

        return (
            <div className="needs">
                <Score
                    key={`leaderboard_needs_${athlete.externalId}`}
                    style={{
                        ...style,
                        ...scoreStyle
                    }}
                >
                    {`${needs.points || ''}`.replace('-', '')}
                </Score>

                <span
                    className="rank"
                    style={style}
                >
                    {hide
                        ? '1st'
                        : t(needs.rank)
                    }
                </span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/table/TableLeaderboard/scored/scores/Needs.js